export * from "./patient.service";
export * from "./duplicate-finder/duplicate-finder.service";



// WEBPACK FOOTER //
// ./src/app/shared/services/patient/index.ts